var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0H16V2H14V0ZM12 4V2H14V4H12ZM10 6V4H12V6H10ZM8 8H10V6H8V8ZM6 10H8V8H6V10ZM4 10V12H6V10H4ZM2 8H4V10H2V8ZM2 8H0V6H2V8Z",
    fill: "rgb(2, 163, 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllowed);
export default __webpack_public_path__ + "static/media/Allowed.7a8b4b9f.svg";
export { ForwardRef as ReactComponent };